import React from 'react';
import styled from 'styled-components/native';
import { REDESIGN_COLORS } from '../../styles/colors';

// ---------- Styled components ----------

const FooterContainer = styled.View`
  align-self: flex-end;
  max-width: 85%;
  padding: 4px 14px 8px 14px;
  margin-bottom: 12px;
`;

const FooterText = styled.Text`
  font-family: Satoshi-Regular;
  font-size: 11px;
  color: ${REDESIGN_COLORS.textSecondary};
  font-style: italic;
`;

// ---------- Component ----------

const BetaFooter = () => (
  <FooterContainer>
    <FooterText>AI-generated draft - review before sending</FooterText>
  </FooterContainer>
);

export default BetaFooter;
